import i18next from "i18next";

import { TAppMethod } from "@/services/app/app.types";

import { TCreatePayloadOptions } from "./app.types";

export const createAppEndpoint = (
  methodName: string,
  appMethod: TAppMethod,
) => `/data/apps/${appMethod}/methods/${methodName}`;

export const createPayload = <T>(payload: T, options?: TCreatePayloadOptions) => {
  return {
    value: {
      ...payload,
      ...options?.locale && getLocale(),
      ...options?.dateRange,
    },
  };
};

export const getLocale = () => {
  return {
    locale: i18next.language,
  };
};
